export default __webpack_public_path__ + "static/media/logo-white.bcdc7b30.svg";